import { CONTACT_ACTION_TYPES } from "./types"

export const ContactActions = {
    checkDuplicatedEmail(payload) {
        return {
            type: CONTACT_ACTION_TYPES.CHECK_DUPLICATED_EMAIL,
            value: payload.value,
            contactId:payload.contactId
        }
    },
    fetchContact(payload) {
        return {
            type: CONTACT_ACTION_TYPES.FETCH_CONTACT,
            contactId:payload,
        }
    },
    checkDuplicatedPhoneNumber(payload) {
        return {
            type: CONTACT_ACTION_TYPES.CHECK_DUPLICATED_EMAIL,
            value: payload.value,
            contactId:payload.contactId
        }
    },
    upsertContact(payload) {
        return {
            type: CONTACT_ACTION_TYPES.UPSERT_CONTACT,
            companyIdentifier: payload.companyIdentifier,
            payload:payload.payloadSupplier,
            contactId: payload.contactId,
            contactType:payload.contactType,
        }
    },
    deleteContact(payload) {
        return {
            type: CONTACT_ACTION_TYPES.DELETE_CONTACT,
            contactId: payload,
        }
    },
}


// WEBPACK FOOTER //
// ./src/state/contact/actions/actions.ts